import { cn } from '../../lib/utils';

interface StepFormSectionProps {
  step?: number;
  title: string;
  description?: string;
  children: React.ReactNode;
  className?: string;
}

export function StepFormSection({
  step,
  title,
  description,
  children,
  className
}: StepFormSectionProps) {
  return (
    <section className={cn('flex flex-col gap-4 border-b dark:border-gray-700 p-6', className)}>
      <div className="flex items-center gap-3">
        {step !== undefined && (
          <span
            className="flex items-center justify-center size-7 rounded-md 
            bg-blue-400/20 text-xs font-semibold text-blue-600
            dark:bg-blue-400/10 dark:text-blue-400"
          >
            {step}
          </span>
        )}
        <div>
          <h3 className="text-sm font-semibold text-foreground">{title}</h3>
          {description && <p className="text-xs text-muted-foreground mt-0.5">{description}</p>}
        </div>
      </div>
      <div className="flex flex-col gap-4">{children}</div>
    </section>
  );
}
